<h3>Detalhar Férias</h3>
<a href="#" class="sr-only">Detalhar Férias</a>

<app-cabecalho-funcional [exercicioSelecionado]="exercicioSelecionado" [exibirPeriodoProgramacaoDisponivel]="false" [exibirTipoPeriodoAquisitivo]="false"></app-cabecalho-funcional>
<p id="mensagem-alteracao-ferias-especiais" class="mb-2 text-danger" *ngIf="mensagemAlteracaoFeriasEspeciais" role="status" aria-live="polite">
    {{ mensagemAlteracaoFeriasEspeciais }}
</p>
<h4 id="titulo-estado-atual-ferias-especiais" *ngIf="exibeTituloEstadoAtualFeriasEspeciais">Estado atual</h4>
<div class="row" *ngIf="!possuiFeriasEspeciaisComParcelas || exercicioAtualDetalhado" [id]="possuiFeriasEspeciaisComParcelas ? 'estado-atual-ferias-especiais' : null" [attr.role]="possuiFeriasEspeciaisComParcelas ? 'region' : null" [attr.aria-labelledby]="exibeTituloEstadoAtualFeriasEspeciais ? 'titulo-estado-atual-ferias-especiais' : null" [attr.aria-label]="possuiFeriasEspeciaisComParcelas && exercicioAtualDetalhado && !exibeTituloEstadoAtualFeriasEspeciais ? 'Dados do exercício atual' : null">
    <div class="col-sm-12">
        <ng-container *ngFor="let carrossel of carrosseisParcelas">
            <p-carousel [value]="carrossel.parcelasFerias" [numVisible]="1" [numScroll]="1" [page]="carrossel.parcelasFerias.length - 1" [circular]="carrossel.parcelasFerias.length > 1" [showIndicators]="carrossel.parcelasFerias.length > 1">
                <ng-template let-parcela pTemplate="item">
                    <h4 style="color: var(--active)">{{ parcela.ordem + (parcela.geracao > 0 ? "." + parcela.geracao : "") }}ª Parcela</h4>
                    <div class="br-card" style="margin-left: 3px; margin-right: 3px">
                        <div class="row" style="margin-left: 0px; margin-right: 0px">
                            <div class="col-12 col-lg-2 mt-2">
                                <label>Período de Férias</label>
                                <br />
                                <p class="mb-0">
                                    {{ parcela.dataInicio | dataFormatada }} a
                                    {{ parcela.dataFim | dataFormatada }}
                                </p>
                            </div>
                            <div class="col-12 col-lg-2 mt-2">
                                <label>Quantidade de dias</label>
                                <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                            </div>
                            <div class="col-12 col-lg-2 mt-2 desktop-only">
                                <label>Situação</label>
                                <br />
                                <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                            </div>
                        </div>
                        <div class="row" style="margin-left: 0px; margin-right: 0px">
                            <div class="col-12 col-lg-2 mt-2">
                                <p class="label mb-1">Adicionais de Férias</p>
                                <p class="mb-0" *ngIf="parcela.adiantamentoDecimoTerceiro.valor">Adiantamento 13º</p>
                                <p class="mb-0" *ngIf="parcela.adiantamentoSalarial.valor">Adiantamento Salarial</p>
                                <p class="mb-0" *ngIf="parcela.abonoPecuniario.valor">Abono Pecuniário</p>
                                <p class="mb-0" *ngIf="!parcela.adiantamentoDecimoTerceiro.valor && !parcela.adiantamentoSalarial.valor && !parcela.abonoPecuniario.valor">Não solicitado</p>
                            </div>
                            <div class="col-12 col-lg-2 mt-2 br-input" *ngIf="parcela.adiantamentoSalarial.valor">
                                <p class="label mb-1">Parcelas de Desconto</p>
                                <p class="mb-0">{{ parcela.parcelasDesconto }}</p>
                            </div>
                        </div>
                        <div class="row mobile-only" style="margin-left: 0px; margin-right: 0px">
                            <div class="col-12 col-lg-12 mt-2">
                                <label>Situação</label>
                                <br />
                                <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                            </div>
                        </div>
                        <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.situacao.descricao === 'Interrompida'">
                            <div class="col-12 col-lg-4" style="padding-left: 0px !important; padding-right: 0px !important" *ngIf="parcela.dataInterrupcao || parcela.motivoLegal || parcela.documentoLegal || parcela.dataPublicacaoDocumentoLegal">
                                <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.dataInterrupcao || parcela.motivoLegal">
                                    <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.dataInterrupcao">
                                        <p class="label mb-1">Data da Interrupção</p>
                                        <p class="mb-0">
                                            {{ parcela.dataInterrupcao | dataFormatada }}
                                        </p>
                                    </div>
                                    <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.motivoLegal">
                                        <p class="label mb-1">Motivo Legal</p>
                                        <p class="mb-0">{{ parcela.motivoLegal }}</p>
                                    </div>
                                </div>
                                <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.documentoLegal || parcela.dataPublicacaoDocumentoLegal">
                                    <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.documentoLegal">
                                        <p class="label mb-1">Documento Legal</p>
                                        <p class="mb-0">{{ parcela.documentoLegal }}</p>
                                    </div>
                                    <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.dataPublicacaoDocumentoLegal">
                                        <p class="label mb-1">Data da Publicação</p>
                                        <p class="mb-0">
                                            {{ parcela.dataPublicacaoDocumentoLegal | dataFormatada }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-8" style="padding-left: 0px !important; padding-right: 0px !important">
                                <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.justificativaInterrupcao">
                                    <div class="col-12 mt-2 br-input">
                                        <p class="label mb-1">Justificativa de interrupção da parcela</p>
                                        <p class="mb-0">{{ parcela.justificativaInterrupcao }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="padding-bottom: 10px">
                            <!--padding-bottom-->
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="previousicon">
                    <span class="fas fa-chevron-left"></span>
                </ng-template>
                <ng-template pTemplate="nexticon">
                    <span class="fas fa-chevron-right"></span>
                </ng-template>
            </p-carousel>
        </ng-container>

        <p-accordion id="accordion-parcelas-canceladas" *ngIf="parcelasFeriasCanceladas.length > 0">
            <p-accordionTab header="Parcelas Canceladas">
                <div class="br-card" style="margin-left: 3px; margin-right: 3px" *ngFor="let parcela of parcelasFeriasCanceladas">
                    <div class="row" style="margin-left: 0px; margin-right: 0px">
                        <div class="col-12 col-lg-2 mt-2">
                            <label>Período de Férias</label>
                            <br />
                            <p class="mb-0">
                                {{ parcela.dataInicio | dataFormatada }} a
                                {{ parcela.dataFim | dataFormatada }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-2 mt-2">
                            <label>Quantidade de dias</label>
                            <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                        </div>
                        <div class="col-12 col-lg-2 mt-2 desktop-only">
                            <label>Situação</label>
                            <br />
                            <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                        </div>
                    </div>
                    <div class="row" style="margin-left: 0px; margin-right: 0px">
                        <div class="col-12 col-lg-2 mt-2">
                            <p class="label mb-1">Adicionais de Férias</p>
                            <p class="mb-0" *ngIf="parcela.adiantamentoDecimoTerceiro.valor">Adiantamento 13º</p>
                            <p class="mb-0" *ngIf="parcela.adiantamentoSalarial.valor">Adiantamento Salarial</p>
                            <p class="mb-0" *ngIf="parcela.abonoPecuniario.valor">Abono Pecuniário</p>
                            <p class="mb-0" *ngIf="!parcela.adiantamentoDecimoTerceiro.valor && !parcela.adiantamentoSalarial.valor && !parcela.abonoPecuniario.valor">Não solicitado</p>
                        </div>
                        <div class="col-12 col-lg-2 mt-2 br-input" *ngIf="parcela.adiantamentoSalarial.valor">
                            <p class="label mb-1">Parcelas de Desconto</p>
                            <p class="mb-0">{{ parcela.parcelasDesconto }}</p>
                        </div>
                    </div>
                    <div class="row mobile-only" style="margin-left: 0px; margin-right: 0px">
                        <div class="col-12 col-lg-12 mt-2">
                            <label>Situação</label>
                            <br />
                            <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                        </div>
                    </div>
                    <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.situacao.descricao === 'Interrompida'">
                        <div class="col-12 col-lg-4" style="padding-left: 0px !important; padding-right: 0px !important" *ngIf="parcela.dataInterrupcao || parcela.motivoLegal || parcela.documentoLegal || parcela.dataPublicacaoDocumentoLegal">
                            <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.dataInterrupcao || parcela.motivoLegal">
                                <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.dataInterrupcao">
                                    <p class="label mb-1">Data da Interrupção</p>
                                    <p class="mb-0">
                                        {{ parcela.dataInterrupcao | dataFormatada }}
                                    </p>
                                </div>
                                <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.motivoLegal">
                                    <p class="label mb-1">Motivo Legal</p>
                                    <p class="mb-0">{{ parcela.motivoLegal }}</p>
                                </div>
                            </div>
                            <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.documentoLegal || parcela.dataPublicacaoDocumentoLegal">
                                <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.documentoLegal">
                                    <p class="label mb-1">Documento Legal</p>
                                    <p class="mb-0">{{ parcela.documentoLegal }}</p>
                                </div>
                                <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.dataPublicacaoDocumentoLegal">
                                    <p class="label mb-1">Data da Publicação</p>
                                    <p class="mb-0">
                                        {{ parcela.dataPublicacaoDocumentoLegal | dataFormatada }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-8" style="padding-left: 0px !important; padding-right: 0px !important">
                            <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.justificativaInterrupcao">
                                <div class="col-12 mt-2 br-input">
                                    <p class="label mb-1">Justificativa de interrupção da parcela</p>
                                    <p class="mb-0">{{ parcela.justificativaInterrupcao }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 10px">
                        <!--padding-bottom-->
                    </div>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>
<div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="(!possuiFeriasEspeciaisComParcelas || exercicioAtualDetalhado) && justificativaAcumuloFerias">
    <div class="col-12 col-lg-12 mt-2 ml-5 mr-5">
        <p class="label mb-1">Justificativa para Acúmulo de Férias</p>
        <p class="mb-0" *ngFor="let justificativaAcumulo of this.justificativaAcumuloFerias">
            {{ justificativaAcumulo }}
        </p>
    </div>
</div>
<div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="(!possuiFeriasEspeciaisComParcelas || exercicioAtualDetalhado) && exercicioSelecionado.justificativaPerdaDireito">
    <div class="col-12 col-lg-12 mt-2 ml-5 mr-5">
        <p class="label mb-1">Justificativa para Perda de Direito</p>
        <p class="mb-0">{{ exercicioSelecionado.justificativaPerdaDireito }}</p>
    </div>
</div>
<section id="secao-detalhamento-ferias-especiais" class="row mt-4" *ngIf="possuiFeriasEspeciais" aria-labelledby="titulo-detalhamento-ferias-especiais">
    <div class="col-12">
        <h4 id="titulo-detalhamento-ferias-especiais">
            {{ possuiFeriasEspeciaisComParcelas ? "Operação de Férias Especiais com Parcelas" : "Operação de Férias Especiais" }}
        </h4>

        <p class="mb-2" id="modalidade-ferias-especiais">
            <span class="label">Modalidade:</span>
            {{ descricaoModalidadeFeriasEspeciais }}
            <span class="sr-only">{{ textoAlternativoModalidadeFeriasEspeciais }}</span>
        </p>

        <p class="mb-2" id="carregando-detalhamento-ferias-especiais" *ngIf="carregandoDetalhamentoFeriasEspeciais" aria-live="polite">Carregando o histórico da operação de férias especiais.</p>

        <p class="mb-3" id="estado-atual-ferias-especiais-ausente" *ngIf="possuiFeriasEspeciaisComParcelas && !carregandoDetalhamentoFeriasEspeciais && !exercicioAtualDetalhado" role="status" aria-live="polite">Estado atual não disponível para esta operação.</p>

        <div id="dados-processo-ferias-especiais" class="br-card mb-3" *ngIf="exibeDadosProcessoFeriasEspeciais">
            <h5 class="mb-2" *ngIf="possuiFeriasEspeciaisSemParcelas">Processo e Justificativa das Férias Especiais</h5>
            <ng-container *ngIf="possuiFeriasEspeciaisSemParcelas; else dadosOperacaoComParcelas">
                <ng-container *ngIf="modalidadeFeriasEspeciais?.id === 'JSP'; else dadosAdministrativosSemParcelas">
                    <div id="linha-campos-jsp-1" class="row">
                        <div class="col-12 col-lg-3 mt-2 br-input">
                            <p class="label mb-1">{{ rotuloNumeroProcessoFeriasEspeciais }}</p>
                            <p class="mb-0">
                                {{ operacaoFeriasEspeciais?.numeroProcesso || "Não informado" }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-3 mt-2 br-input">
                            <p class="label mb-1">{{ rotuloFundamentacaoFeriasEspeciais }}</p>
                            <p class="mb-0">
                                {{ operacaoFeriasEspeciais?.fundamentacao || "Não informado" }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-3 mt-2 br-input">
                            <p class="label mb-1">Quantidade de Dias</p>
                            <p class="mb-0">
                                {{ exercicioAtualDetalhado?.quantidadeDias ?? "Não informado" }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-3 mt-2 br-input">
                            <p class="label mb-1">Máximo de Parcelas Férias</p>
                            <p class="mb-0">
                                {{ exercicioAtualDetalhado?.quantidadeMaximaParcelas ?? "Não informado" }}
                            </p>
                        </div>
                    </div>
                    <div id="linha-campos-jsp-2" class="row">
                        <div class="col-12 col-lg-3 mt-2 br-input">
                            <p class="label mb-1">Tipo de Aquisição de Férias</p>
                            <p class="mb-0">
                                {{ obterDescricaoTipoPeriodoAquisitivo(exercicioAtualDetalhado?.tipoPeriodoAquisitivo) || "Não informado" }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-3 mt-2 br-input">
                            <p class="label mb-1">Início Período de Programação</p>
                            <p class="mb-0">
                                {{ (exercicioAtualDetalhado?.dataInicioPeriodoProgramacao | dataFormatada) || "Não informado" }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-3 mt-2 br-input">
                            <p class="label mb-1">Fim Período de Programação</p>
                            <p class="mb-0">
                                {{ (exercicioAtualDetalhado?.dataFimPeriodoProgramacao | dataFormatada) || "Não informado" }}
                            </p>
                        </div>
                    </div>
                </ng-container>
                <ng-template #dadosAdministrativosSemParcelas>
                    <div class="row">
                        <div class="col-12 col-lg-4 mt-2 br-input">
                            <p class="label mb-1">{{ rotuloNumeroProcessoFeriasEspeciais }}</p>
                            <p class="mb-0">
                                {{ operacaoFeriasEspeciais?.numeroProcesso || "Não informado" }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-2 mt-2 br-input">
                            <p class="label mb-1">Quantidade de Dias</p>
                            <p class="mb-0">
                                {{ exercicioAtualDetalhado?.quantidadeDias ?? "Não informado" }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-6 mt-2 br-input">
                            <p class="label mb-1">{{ rotuloFundamentacaoFeriasEspeciais }}</p>
                            <p class="mb-0">
                                {{ operacaoFeriasEspeciais?.fundamentacao || "Não informado" }}
                            </p>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
            <ng-template #dadosOperacaoComParcelas>
                <div class="row">
                    <div class="col-12 col-lg-4 mt-2 br-input" *ngIf="operacaoFeriasEspeciais?.numeroProcesso">
                        <p class="label mb-1">Número do processo</p>
                        <p class="mb-0">{{ operacaoFeriasEspeciais?.numeroProcesso }}</p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2 br-input" *ngIf="operacaoFeriasEspeciais?.dataOperacao">
                        <p class="label mb-1">Data da operação</p>
                        <p class="mb-0">
                            {{ dataOperacaoFeriasEspeciaisFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-12 mt-2 br-input" *ngIf="operacaoFeriasEspeciais?.fundamentacao">
                        <p class="label mb-1">Fundamentação</p>
                        <p class="mb-0">{{ operacaoFeriasEspeciais?.fundamentacao }}</p>
                    </div>
                </div>
            </ng-template>
        </div>

        <div id="historico-ferias-especiais-indisponivel" class="br-message warning mb-3" role="alert" *ngIf="historicoFeriasEspeciaisIndisponivel">
            <span class="sr-only">Aviso:</span>
            <span>
                Histórico indisponível. O estado original do exercício não pode ser apresentado.
                {{ motivoHistoricoFeriasEspeciaisIndisponivel }}
            </span>
        </div>

        <p-accordion id="accordion-exercicio-original-ferias-especiais" *ngIf="exercicioOriginalDetalhado; else semEstadoOriginal">
            <p-accordionTab header="Exercício Original (antes da primeira ação de Férias Especiais)">
                <section id="estado-original-ferias-especiais" aria-label="Dados do exercício e parcelas antes da ação de férias especiais">
                    <ng-container *ngTemplateOutlet="blocoExercicio; context: { exercicio: exercicioOriginalDetalhado }"></ng-container>
                </section>
            </p-accordionTab>
        </p-accordion>
        <ng-template #semEstadoOriginal>
            <p class="mb-3" id="estado-original-ferias-especiais-ausente">Estado original não disponível.</p>
        </ng-template>
    </div>
</section>

<ng-template #blocoExercicio let-exercicio="exercicio">
    <ng-container *ngIf="possuiFeriasEspeciaisSemParcelas; else resumoExercicioOriginalComParcelas">
        <section id="resumo-exercicio-original-sem-parcelas" class="br-card bg-gray-5 mb-3" aria-label="Resumo do exercício original">
            <div class="card-content">
                <div class="row">
                    <div class="col-12 col-lg-4 mt-2">
                        <p class="label mb-1">Situação do Exercício</p>
                        <p class="mb-2">
                            {{ obterDescricaoSituacaoExercicio(exercicio.situacao) }}
                        </p>
                        <p class="label mb-1">Tipo de Período Aquisitivo</p>
                        <p id="tipo-periodo-aquisitivo-exercicio-original" class="mb-0">
                            {{ obterDescricaoTipoPeriodoAquisitivo(exercicio.tipoPeriodoAquisitivo) || "Não informado" }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <p class="label mb-1">Período aquisitivo</p>
                        <p class="mb-2">
                            {{ exercicio.dataInicioPeriodoAquisitivo | dataFormatada }} a
                            {{ exercicio.dataFimPeriodoAquisitivo | dataFormatada }}
                        </p>
                        <p class="label mb-1">Período de programação</p>
                        <p class="mb-0">
                            {{ exercicio.dataInicioPeriodoProgramacao | dataFormatada }} a
                            {{ exercicio.dataFimPeriodoProgramacao | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 mt-2">
                        <p class="label mb-1">Quantidade de Dias</p>
                        <p class="mb-0">{{ exercicio.quantidadeDias }}</p>
                    </div>
                </div>
            </div>
        </section>
    </ng-container>
    <ng-template #resumoExercicioOriginalComParcelas>
        <div class="br-card mb-3">
            <div class="row">
                <div class="col-12 col-lg-2 mt-2 br-input">
                    <p class="label mb-1">Ano do exercício</p>
                    <p class="mb-0">{{ exercicio.anoExercicio }}</p>
                </div>
                <div class="col-12 col-lg-2 mt-2 br-input">
                    <p class="label mb-1">Situação</p>
                    <p class="mb-0">
                        {{ obterDescricaoSituacaoExercicio(exercicio.situacao) }}
                    </p>
                </div>
                <div class="col-12 col-lg-2 mt-2 br-input">
                    <p class="label mb-1">Quantidade de dias</p>
                    <p class="mb-0">{{ exercicio.quantidadeDias }}</p>
                </div>
                <div class="col-12 col-lg-3 mt-2 br-input">
                    <p class="label mb-1">Período aquisitivo</p>
                    <p class="mb-0">
                        {{ exercicio.dataInicioPeriodoAquisitivo | dataFormatada }} a
                        {{ exercicio.dataFimPeriodoAquisitivo | dataFormatada }}
                    </p>
                </div>
                <div class="col-12 col-lg-3 mt-2 br-input">
                    <p class="label mb-1">Período de programação</p>
                    <p class="mb-0">
                        {{ exercicio.dataInicioPeriodoProgramacao | dataFormatada }} a
                        {{ exercicio.dataFimPeriodoProgramacao | dataFormatada }}
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-3 mt-2 br-input" *ngIf="exercicio.quantidadeMaximaParcelas !== null && exercicio.quantidadeMaximaParcelas !== undefined">
                    <p class="label mb-1">Quantidade máxima de parcelas</p>
                    <p class="mb-0">{{ exercicio.quantidadeMaximaParcelas }}</p>
                </div>
                <div class="col-12 col-lg-3 mt-2 br-input" *ngIf="exercicio.extraordinario !== null && exercicio.extraordinario !== undefined">
                    <p class="label mb-1">Exercício extraordinário</p>
                    <p class="mb-0">{{ exercicio.extraordinario ? "Sim" : "Não" }}</p>
                </div>
            </div>
        </div>
    </ng-template>

    <p class="mb-2">Parcelas do exercício original</p>
    <div class="row" id="parcelas-estado-original-ferias-especiais" *ngIf="exercicio.parcelas?.length; else semParcelasHistoricas">
        <div class="col-12" *ngFor="let parcela of exercicio.parcelas; let i = index">
            <h4 style="color: var(--active)">{{ parcela.ordem ?? i + 1 }}ª Parcela</h4>
            <div class="br-card" style="margin-left: 3px; margin-right: 3px">
                <div class="row">
                    <div class="col-12 col-lg-2 mt-2">
                        <label>Período de Férias</label>
                        <br />
                        <p class="mb-0">
                            {{ parcela.dataInicio | dataFormatada }} a
                            {{ parcela.dataFim | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2">
                        <label>Quantidade de dias</label>
                        <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 desktop-only">
                        <label>Situação Parcela</label>
                        <br />
                        <p-tag [value]="obterDescricaoSituacaoParcela(parcela.situacao)" styleClass="text" [style]="{ background: 'linear-gradient(' + corSituacaoParcela(parcela.situacao) + ' 100%,' + corSituacaoParcela(parcela.situacao) + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-2 mt-2 br-input">
                        <p class="label mb-1">Adicionais de Férias</p>
                        <p class="mb-0" *ngIf="parcela.adiantamentoDecimoTerceiro">Adiantamento 13º</p>
                        <p class="mb-0" *ngIf="parcela.adiantamentoSalarial">Adiantamento Salarial</p>
                        <p class="mb-0" *ngIf="parcela.abonoPecuniario">Abono Pecuniário</p>
                        <p class="mb-0" *ngIf="!parcela.adiantamentoDecimoTerceiro && !parcela.adiantamentoSalarial && !parcela.abonoPecuniario">Não solicitado</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 br-input" *ngIf="parcela.adiantamentoSalarial && parcela.parcelasDesconto !== null && parcela.parcelasDesconto !== undefined">
                        <p class="label mb-1">Parcelas de Desconto</p>
                        <p class="mb-0">{{ parcela.parcelasDesconto }}</p>
                    </div>
                </div>
                <div class="row mobile-only">
                    <div class="col-12 col-lg-12 mt-2">
                        <label>Situação Parcela</label>
                        <br />
                        <p-tag [value]="obterDescricaoSituacaoParcela(parcela.situacao)" styleClass="text" [style]="{ background: 'linear-gradient(' + corSituacaoParcela(parcela.situacao) + ' 100%,' + corSituacaoParcela(parcela.situacao) + ' 100%)' }"></p-tag>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #semParcelasHistoricas>
        <p class="mb-3" id="parcelas-estado-original-ferias-especiais">Nenhuma parcela disponível.</p>
    </ng-template>
</ng-template>

<div class="row mt-2">
    <div class="col text-right">
        <button aria-label="botão voltar" id="botao-voltar" pButton type="button" label="Voltar" class="primary botao-responsivo" (click)="voltar()"></button>
    </div>
</div>
